define('collections/Podio.Collections.ConversationEvents',['require','underscore','lib/backbone/Backbone.PodioCollection','lib/Podio.Routes','models/Podio.Models.ConversationEvent','lib/backbone/Backbone.Mixins.PodioInfiniteScrollCollection','lib/backbone/Backbone.Mixins.PodioCollectionDateComparator'],function(require) {

  var _ = require('underscore');
  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var routes = require('lib/Podio.Routes');

  return PodioCollection.extend({
    configure: function() {
      this.model = require('models/Podio.Models.ConversationEvent');
    },

    initialize: function(models, options) {
      if (options && options.id) {
        this.setConversationId(options.id);
      }

      var CollectionInfiniteScroll = require('lib/backbone/Backbone.Mixins.PodioInfiniteScrollCollection');
      _.extend(this, CollectionInfiniteScroll);

      // Sort collection by last event timestamp
      var CollectionDateComparator = require('lib/backbone/Backbone.Mixins.PodioCollectionDateComparator');
      _.extend(this, CollectionDateComparator);
      this.dateComparatorAttribute = 'created_on';
    },

    setConversationId: function(modelId) {
      this.conversationId = modelId;
      this.url = routes.conversation_events_path(modelId, { format: '' });
    }
  });

});

